import { useTranslation } from 'react-i18next';
import styles from "./appLogin.module.css";

const AppLogin = ({ onCancel, onLogin }) => {
  const { t } = useTranslation(); // hook para traduzir

  return (
    <div className={styles.wrapper}>
      {/* Scenery with Clouds and Birds */}
      <div className={styles.scenery}>
        <svg className={`${styles.cloud} ${styles.cloud1}`} viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.5 19C19.9853 19 22 16.9853 22 14.5C22 12.1325 20.1772 10.2052 17.854 10.0146C17.4338 6.64333 14.5683 4 11 4C7.13401 4 4 7.13401 4 11C4 11.2033 4.00863 11.4046 4.02549 11.6033C2.30877 12.1264 1 13.7226 1 15.5C1 17.9853 3.01472 20 5.5 20H17.5Z" />
        </svg>
        <svg className={`${styles.cloud} ${styles.cloud2}`} viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.5 19C19.9853 19 22 16.9853 22 14.5C22 12.1325 20.1772 10.2052 17.854 10.0146C17.4338 6.64333 14.5683 4 11 4C7.13401 4 4 7.13401 4 11C4 11.2033 4.00863 11.4046 4.02549 11.6033C2.30877 12.1264 1 13.7226 1 15.5C1 17.9853 3.01472 20 5.5 20H17.5Z" />
        </svg>
        <svg className={`${styles.cloud} ${styles.cloud3}`} viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.5 19C19.9853 19 22 16.9853 22 14.5C22 12.1325 20.1772 10.2052 17.854 10.0146C17.4338 6.64333 14.5683 4 11 4C7.13401 4 4 7.13401 4 11C4 11.2033 4.00863 11.4046 4.02549 11.6033C2.30877 12.1264 1 13.7226 1 15.5C1 17.9853 3.01472 20 5.5 20H17.5Z" />
        </svg>
        <svg className={`${styles.cloud} ${styles.cloud4}`} viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.5 19C19.9853 19 22 16.9853 22 14.5C22 12.1325 20.1772 10.2052 17.854 10.0146C17.4338 6.64333 14.5683 4 11 4C7.13401 4 4 7.13401 4 11C4 11.2033 4.00863 11.4046 4.02549 11.6033C2.30877 12.1264 1 13.7226 1 15.5C1 17.9853 3.01472 20 5.5 20H17.5Z" />
        </svg>
        <svg className={`${styles.cloud} ${styles.cloud5}`} viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.5 19C19.9853 19 22 16.9853 22 14.5C22 12.1325 20.1772 10.2052 17.854 10.0146C17.4338 6.64333 14.5683 4 11 4C7.13401 4 4 7.13401 4 11C4 11.2033 4.00863 11.4046 4.02549 11.6033C2.30877 12.1264 1 13.7226 1 15.5C1 17.9853 3.01472 20 5.5 20H17.5Z" />
        </svg>
        <div className={styles.birdContainer}>
          <svg className={styles.birdSvg} viewBox="0 0 100 50" width="60" height="30" fill="none" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round">
            <path className={styles.birdWings} d="M 10 30 Q 30 10 50 30 Q 70 10 90 30" />
          </svg>
        </div>
        <div className={`${styles.birdContainer} ${styles.birdContainer2}`}>
          <svg className={styles.birdSvg} viewBox="0 0 100 50" width="45" height="22" fill="none" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round">
            <path className={styles.birdWings} d="M 10 30 Q 30 10 50 30 Q 70 10 90 30" />
          </svg>
        </div>
      </div>

      {/* Login Card */}
      <div className={styles.content}>
        <div className={styles.card}>
          <div className={styles.header}>
            <h1 className={styles.title}>tS notes</h1>
            <p className={styles.subtitle}>{t('Welcome!')}</p>
          </div>

          <div className={styles.authOptions}>
            <div className={styles.optionGroup}>
              <div className={styles.optionHeader}>
                <h2 className={styles.optionTitle}>{t('Log in with a tS notes account')}</h2>
                <p className={styles.optionDescription}>{t('Access your existing account')}</p>
                <p className={styles.optionDescription}>{t('Have your notes available on all your devices.')}</p>
              </div>
              <button className={styles.primaryButton} onClick={onCancel}>
                <span className={styles.buttonText}>{t('Login or register')}</span>
                <span className={styles.buttonIcon}>→</span>
              </button>
            </div>

            <div className={styles.divider}>
              <span className={styles.dividerText}>{t('or')}</span>
            </div>

            <div className={styles.optionGroup}>
              <div className={styles.optionHeader}>
                <h2 className={styles.optionTitle}>{t('Continue without an account')}</h2>
                <p className={styles.optionDescription}>{t('Try it without registering')}</p>
                <p className={styles.optionDescription}>{t('Your notes will only be available on this device.')}</p>
              </div>
              <button className={styles.secondaryButton} onClick={onLogin}>
                <span className={styles.buttonText}>{t('Enter without account')}</span>
                <span className={styles.buttonIcon}>→</span>
              </button>
            </div>
          </div>

          <div className={styles.footer}>
            <p className={styles.footerText}>{t('Your data is safe with us')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export { AppLogin };